import { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import { SiteLayout } from "@/components/SiteLayout";
import { Spinner } from "@/components/ui";
import { Book } from "@/pages/book/Book";
import { Manage } from "@/pages/book/Manage";
import { Home } from "@/pages/site/Home";
import { NotFound, ReviewsPage, ServicesPage, StylistPage, TeamPage, VisitPage } from "@/pages/site/pages";

// Staff code stays out of the customer bundle.
const StaffApp = lazy(() => import("@/pages/staff/StaffApp"));
const Schedule = lazy(() => import("@/pages/staff/Schedule").then((m) => ({ default: m.Schedule })));
const Settings = lazy(() => import("@/pages/staff/Settings").then((m) => ({ default: m.Settings })));
const Messages = lazy(() => import("@/pages/staff/Messages").then((m) => ({ default: m.Messages })));

const staffFallback = <Spinner label="Opening the schedule" />;

const router = createBrowserRouter([
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/services", element: <ServicesPage /> },
      { path: "/team", element: <TeamPage /> },
      { path: "/team/:id", element: <StylistPage /> },
      { path: "/reviews", element: <ReviewsPage /> },
      { path: "/visit", element: <VisitPage /> },
      { path: "/book", element: <Book /> },
      { path: "/m/:token", element: <Manage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    path: "/staff",
    element: (
      <Suspense fallback={staffFallback}>
        <StaffApp />
      </Suspense>
    ),
    children: [
      { index: true, element: <Suspense fallback={staffFallback}><Schedule /></Suspense> },
      { path: "settings", element: <Suspense fallback={staffFallback}><Settings /></Suspense> },
      { path: "messages", element: <Suspense fallback={staffFallback}><Messages /></Suspense> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
